var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-content',{staticClass:"md-scrollbar d-flex h-100 ai-start wrapped"},_vm._l((_vm.allowedServicesToShow),function(service,index){return _c('ServiceCard',{key:index,staticClass:"m-15",attrs:{"serviceData":service},on:{"members-click":function($event){return _vm.$emit('serviceSelected', { job: $event, service })}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }